import { useLayoutEffect } from 'react'
import AffirmScript from 'shared/components/AffirmScript'
import styled from 'styled-components'
import { colors } from 'shared/lib'

// Enums should match https://docs.affirm.com/affirm-developers/docs/html-reference
export enum AffirmPromotionalClass {
  AsLowAs = 'affirm-as-low-as',
  SiteModal = 'affirm-site-modal',
  ProductModal = 'affirm-product-modal',
}

export enum AffirmPromotionalPageType {
  Homepage = 'homepage',
  Landing = 'landing',
  Search = 'search',
  Category = 'category',
  Product = 'product',
  Cart = 'cart',
  Payment = 'payment',
  Banner = 'banner',
}

export enum AffirmPromotionalType {
  Text = 'text',
  Symbol = 'symbol',
}

const AffirmTextWrapper = styled.div`
  .affirm-modal-trigger {
    color: ${colors.FC2_GREY};
  }
  p {
    margin: 0;
  }
`

interface IAffirmPromotionalProps {
  amount?: number
  affirmClass?: AffirmPromotionalClass
  affirmType?: AffirmPromotionalType
  pageType: AffirmPromotionalPageType
  className?: string
}

const AffirmPromotional = ({
  amount,
  affirmClass = AffirmPromotionalClass.AsLowAs,
  pageType,
  affirmType = AffirmPromotionalType.Symbol,
  className,
}: IAffirmPromotionalProps) => {
  useLayoutEffect(() => {
    window.affirm?.ui?.ready(() => {
      window.affirm?.ui?.refresh()
    })
  }, [amount])

  // https://docs.affirm.com/Integrate_Affirm/Direct_API#1._Add_Affirm.js
  return (
    <div className={className}>
      <AffirmScript />
      <AffirmTextWrapper>
        <p
          className={affirmClass}
          data-page-type={pageType}
          data-affirm-type={affirmType}
          data-amount={amount}
        />
      </AffirmTextWrapper>
    </div>
  )
}

export default AffirmPromotional
